const environment = {
  socketEndPoint: "https://api.dentalnotesrep.com",
  endPoint: "https://api.dentalnotesrep.com",

  // socketEndPoint: "http://localhost:8000",
  // endPoint: "http://localhost:8000",
};

export default environment;
